var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.531 10.605a.576.576 0 0 1-1.152 0c0-.023.017-.163.211-.455.092-.138.213-.293.365-.465.152.172.273.327.365.465.194.292.211.432.211.455z",
    fill: "#535353",
    stroke: "currentColor",
    strokeWidth: 1.639
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.127 2 3.7 7.427l3.947 3.946 5.426-5.426L9.127 2z",
    stroke: "currentColor",
    strokeWidth: 1.229,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.7 15h8",
    className: "color-sensitive",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillColor);
export default __webpack_public_path__ + "static/media/fillColor.d51a6dd24239c06b7a787d25e161e084.svg";
export { ForwardRef as ReactComponent };